import "./app.css";
import GoToTop from "./Components/GotoTop";
import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import NotFoundPage from "./Components/NotFoundPage";
import Users from "./ComponentsWeb/Main/user/Users";
import Setting from "./Pages/Setting/Setting";
import UserLogin from "./ComponentsWeb/Main/user/UserLogin";
import ChatUI from "./ComponentsWeb/Main/user/ChatUI";
import TemplateList from "./Pages/Templates/TemplateList";

function App() {
  return (
    <>
      <Routes>
        {/* web routes start*/}
        <Route path="/" element={<UserLogin />} />
        <Route path="/users"element={<Users/>}/>
        <Route path="/settings" element={<Setting />} />
        <Route path="/whatsapp" element={<ChatUI />} />
        <Route path="/templates" element={<TemplateList />} />
        <Route path="*" element={<NotFoundPage />} />
        {/* <Route path="/userchat/:chatName" element={<ChatArea />} /> */}
        

        
      </Routes>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        newestOnTop={false}
        closeOnClick
        theme="colored"
      />
      <GoToTop />
    </>
  );
}
export default App;
